// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2TRsD","selected":"Chip_selected__1SOpI"};